import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatStep, MatStepLabel, MatStepper } from '@angular/material/stepper';
import { SiaI18nService } from '../services/i18n.service';

@Component({
  selector: 'dialog-overview-example-dialog',
  template: ` <div mat-dialog-title>
      {{ data.title }}
    </div>

    <div
      mat-dialog-content
      [style]="'width: 100%; margin-bottom: 10px;' + (data.style ?? '')"
    >
      {{ data.text }}
    </div>
    <div style="display:flex; width:100%; justify-content:center">
      <mat-stepper orientation="vertical" [linear]="false" #stepper>
        @for (step of stepperValues; track step) {
          <mat-step>
            <form>
              <ng-template matStepLabel>{{ step.label }}</ng-template>
              <mat-form-field>
                <!-- <mat-label>Name</mat-label> -->
                <input matInput [(ngModel)]="step.value" />
              </mat-form-field>
            </form>
          </mat-step>
        }
      </mat-stepper>
    </div>

    <div
      mat-dialog-actions
      style="display: flex; justify-content: center; gap: 10px"
    >
      <button mat-raised-button color="warn" (click)="onCancelClick()">
        {{ this.translate('ANNULLA') }}
      </button>
      <button
        mat-raised-button
        color="primary"
        (click)="onConfirmClick()"
        [disabled]="checkMandatory()"
      >
        {{ this.translate('CONFERMA') }}
      </button>
    </div>`,
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatStepper,
    MatStep,
    FormsModule,
    MatStepLabel,
    MatFormField,
    MatInput,
    MatDialogActions,
    MatButton,
  ],
})
export class StepperDialogComponent {
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<StepperDialogComponent>>(MatDialogRef);
  protected i18nService = inject(SiaI18nService);

  pageDataSetted: boolean = false;
  stepperValues: any[] = [];

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {
    const data = this.data;

    if (!data.labels) return;
    this.stepperValues = data.labels.map((x: any) => {
      return {
        label: x,
        value: '',
      };
    });
  }

  onCancelClick() {
    this.dialogRef.close(undefined);
  }

  onConfirmClick() {
    // this.data.result = true;
    this.dialogRef.close(this.stepperValues);
  }

  checkMandatory() {
    return !this.stepperValues.every((x) => x.value);
  }
  translate(txt: string) {
    if (txt) {
      return this.i18nService.translate(txt);
    }
    return '';
  }
}
